<mat-card class="spg-mat-card mat-card-cmn" *ngIf="orderList.length === 0 && loaded">
  <mat-card-header>
    <mat-card-title>Orders (0)</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="text-center">
      <img src="assets/img/emptycart.PNG" alt="">
      <br/>
      <span> {{ filterApplied ? 'No order(s) available with selected filters' : 'Seems to be no order(s) have been placed yet'}} </span>
    </div>
  </mat-card-content>
</mat-card>


<mat-card class="spg-mat-card mat-card-cmn"
          *ngIf="!loaded">
  <mat-card-header>
    <mat-card-title>Orders (0)</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="text-center">
      <span> Loading... </span>
    </div>
  </mat-card-content>
</mat-card>
